import { Controller } from 'stimulus';

// Per-card expand / minimize for the jobs index cards. The controller sits on a
// card root (.jlv-card expanded · .jlv-crow compact); a toggle button (the
// compact row's chevron or the expanded card's minimize button) carries
// data-card-url and the target data-density. On click we fetch that single job
// rendered at the target density and replace this element in place. State is
// ephemeral (resets on the next full load); the global Table/Compact/Expanded
// toggle remains the default. Mirrors task_expand_controller.
export default class extends Controller {
  toggle(event) {
    event.preventDefault();
    const btn = event.currentTarget;
    const url = btn.dataset.cardUrl;
    const density = btn.dataset.density;
    if (!url || this.loading) return;

    this.loading = true;
    btn.disabled = true;

    const sep = url.includes('?') ? '&' : '?';
    fetch(`${url}${sep}density=${encodeURIComponent(density)}`, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then((r) => (r.ok ? r.text() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then((html) => {
        const root = this.element;
        root.insertAdjacentHTML('afterend', html.trim());
        root.remove();
      })
      .catch((err) => {
        console.error('Card expand/minimize failed:', err);
        this.loading = false;
        btn.disabled = false;
      });
  }
}
